import {
  buildComplianceAnswerFormKey,
  buildNumericAnswerFormKey,
  buildOptionSelectionAnswerFormKey,
  buildTextAnswerFormKey,
} from 'shared/domain/protocolAnswer/formKeys';
import {
  isComplianceProtocolAnswer,
  isNumericProtocolAnswer,
  isTextProtocolAnswer,
  isOptionSelectionProtocolAnswer,
  ProtocolAnswer,
} from 'shared/domain/protocolAnswer';
import { HashMap } from 'shared/types/commonView';

export function protocolAnswersToFlatFormEntries(
  checklistItemId: string,
  answers: ProtocolAnswer[] | undefined
): HashMap<unknown> {
  const entries: HashMap<unknown> = {};

  if (!answers?.length) {
    return entries;
  }

  answers.forEach((answer) => {
    if (
      isComplianceProtocolAnswer(answer) &&
      answer.selectedOption !== undefined
    ) {
      entries[buildComplianceAnswerFormKey(checklistItemId, answer.checklistAnswerId)] =
        answer.selectedOption;
    }

    if (isNumericProtocolAnswer(answer) && answer.numericValue !== undefined) {
      entries[buildNumericAnswerFormKey(checklistItemId, answer.checklistAnswerId)] =
        answer.numericValue;
    }

    if (isTextProtocolAnswer(answer) && answer.textValue !== undefined) {
      entries[buildTextAnswerFormKey(checklistItemId, answer.checklistAnswerId)] =
        answer.textValue;
    }

    if (
      isOptionSelectionProtocolAnswer(answer) &&
      answer.selectedOptionIds !== undefined
    ) {
      entries[
        buildOptionSelectionAnswerFormKey(checklistItemId, answer.checklistAnswerId)
      ] = answer.selectedOptionIds;
    }
  });

  return entries;
}
